import FilterVector from '@/assets/images/svg/FilterVector';
import { Dialog, Loading } from '@/components';
import { CustomTable } from '@/components/Table';
import Pagination from '@/components/Utils/Pagination';
import React, { Fragment, ReactNode } from 'react';
import { Container } from 'reactstrap';
import Page from '@/model/Page';
import { EventMoneyTransfer } from '@/model/EventMoneyTransfer';
import { ActionProps } from '@/components/Dialog';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { toCurrency } from '@/helpers/masks/toCurrency';
import dayjs from 'dayjs';
import { ReactComponent as Detail } from '@/assets/images/svg/detail.svg';
import { ReactComponent as Transfer } from '@/assets/images/svg/transfer.svg';
import { ReactComponent as CloseX } from '@/assets/images/svg/closeX.svg';
import { PixKey } from '@/model/PixKey';
import PixType from '@/model/PixType';
import { updateMask as updateMaskCpfCnpj } from '@/helpers/masks/cpfCnpj';
import { updateMask } from '@/helpers/masks/mobilePhone';
import { GroupedByEvent } from '@/model/GroupedByEvent';
import { columns, ShouldShowModal, States } from '../../types';
import { FilterContent } from '../../components/FilterContent';
import { DetailContent } from '../../components/DetailContent';
import { RefuseContent } from '../../components/RefuseContent';

interface StateProps {
  state: States;
  title: string | ReactNode;
  visible: boolean;
  shouldShowModal: ShouldShowModal;
  formData: FormData;
  formErrors: FormErrors;
  page: Page<EventMoneyTransfer, EventMoneyTransfer>;
  formDataRefuse: FormData;
  formErrorsRefuse: FormErrors;
  groupedByEvent: GroupedByEvent[];
}

interface DispatchProps {
  onToggle: () => void;
  onShouldShowModal: ({
    value,
    newTitleModal,
    id,
  }: {
    value: ShouldShowModal;
    newTitleModal: string | React.ReactNode;
    id?: string;
  }) => void;
  onChangeFormInput: OnChangeFormInput;
  onClearFilter: () => void;
  onFilter: () => void;
  onPaginationChange: (newPageNumber: number) => void;
  eventMoneyTransfer?: EventMoneyTransfer;
  onChangeFormInputRefuse: OnChangeFormInput;
  onTransfer: (id: string) => void;
  onRefuse: () => void;
}

type Props = StateProps & DispatchProps;
export const RedemptionContainer: React.FC<Props> = ({
  state,
  title,
  visible,
  groupedByEvent,
  onToggle,
  shouldShowModal,
  onShouldShowModal,
  formData,
  formErrors,
  onChangeFormInput,
  onClearFilter,
  onFilter,
  page,
  onPaginationChange,
  eventMoneyTransfer,
  formDataRefuse,
  formErrorsRefuse,
  onChangeFormInputRefuse,
  onTransfer,
  onRefuse,
}): JSX.Element => {
  const renderActionDialogToCancelFilter: ActionProps = {
    title: 'Limpar',
    onClick: (): void => onClearFilter(),
    theme: 'noneBorder',
  };
  const renderActionDialogToCancel: ActionProps = {
    title: 'Fechar',
    onClick: (): void => onToggle(),
    theme: 'noneBorder',
  };
  const maskPixKey = (pixKey: PixKey): string => {
    let value = '';
    if (pixKey.pixKeyType === PixType.CPF) {
      value = updateMaskCpfCnpj(pixKey.key);
    } else if (pixKey.pixKeyType === PixType.CELL) {
      value = updateMask(pixKey.key);
    } else {
      return pixKey.key;
    }
    return value;
  };

  // const dataTable =
  //   page && page.list && page.list.length > 0
  //     ? page.list.map(item => ({
  //         event: item.event.name,
  //         recipient: item.pixKey.recipient ? item.pixKey.recipient : 'Não Cadastrado',
  //         bank: item.pixKey.bank.fullName,
  //         pixKey: maskPixKey(item.pixKey),
  //         transferValue: toCurrency(item.transferValue),
  //         transferRequestDate: dayjs(item.transferRequestDate).format('DD/MM/YYYY HH:mm:ss'),
  //         action: (
  //           <React.Fragment>
  //             <Detail
  //               className={'mr-4 svg-icon action-icon'}
  //               onClick={() =>
  //                 onShouldShowModal({
  //                   value: ShouldShowModal.detail,
  //                   newTitleModal: 'Pedido',
  //                   id: item.id,
  //                 })
  //               }
  //             />
  //             {(!item.refusedDate || (!item.transferDate && item.transferStatus === 0)) && (
  //               <React.Fragment>
  //                 <Transfer
  //                   title="Resgatar"
  //                   className={'mr-4 svg-icon-error action-icon'}
  //                   onClick={() => onTransfer(item.id)}
  //                 />
  //                 <CloseX
  //                   title="Recusar"
  //                   className={'mr-4 svg-icon-error action-icon'}
  //                   onClick={() =>
  //                     onShouldShowModal({
  //                       value: ShouldShowModal.refuse,
  //                       newTitleModal: 'Recusar',
  //                       id: item.id,
  //                     })
  //                   }
  //                 />
  //               </React.Fragment>
  //             )}
  //           </React.Fragment>
  //         ),
  //       }))
  //     : [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dataTable = (data: EventMoneyTransfer[]): any[] => {
    if (!data || data.length === 0) return [];
    const content = data.map(item => ({
      event: item.event.name,
      recipient: item.pixKey.recipient ? item.pixKey.recipient : 'Não Cadastrado',
      bank: item.pixKey.bank.fullName,
      pixKey: maskPixKey(item.pixKey),
      transferValue: toCurrency(item.transferValue),
      transferRequestDate: dayjs(item.transferRequestDate).format('DD/MM/YYYY HH:mm:ss'),
      action: (
        <React.Fragment>
          <Detail
            className={'mr-4 svg-icon action-icon'}
            onClick={() =>
              onShouldShowModal({
                value: ShouldShowModal.detail,
                newTitleModal: 'Pedido',
                id: item.id,
              })
            }
          />
          {(!item.refusedDate || (!item.transferDate && item.transferStatus === 0)) && (
            <React.Fragment>
              <Transfer
                title="Resgatar"
                className={'mr-4 svg-icon-error action-icon'}
                onClick={() => onTransfer(item.id)}
              />
              <CloseX
                title="Recusar"
                className={'mr-4 svg-icon-error action-icon'}
                onClick={() =>
                  onShouldShowModal({
                    value: ShouldShowModal.refuse,
                    newTitleModal: 'Recusar',
                    id: item.id,
                  })
                }
              />
            </React.Fragment>
          )}
        </React.Fragment>
      ),
    }));
    return content;
  };

  return (
    <Fragment>
      <Loading isVisible={state === States.loading} />
      <Dialog
        title={title}
        visible={visible}
        onClose={onToggle}
        footerBorder={'top'}
        position={shouldShowModal === ShouldShowModal.filter ? 'right' : 'center'}
        isContentWithCard={shouldShowModal !== ShouldShowModal.filter}
        actions={[
          {
            [ShouldShowModal.filter]: renderActionDialogToCancelFilter,
            [ShouldShowModal.detail]: renderActionDialogToCancel,
            [ShouldShowModal.refuse]: renderActionDialogToCancel,
          }[shouldShowModal],
          {
            [ShouldShowModal.filter]: {
              title: 'Aplicar',
              onClick: onFilter,
            },
            [ShouldShowModal.detail]: {},
            [ShouldShowModal.refuse]: { title: 'Recusar', onClick: onRefuse },
          }[shouldShowModal],
        ]}
      >
        {
          {
            [ShouldShowModal.filter]: (
              <FilterContent
                formData={formData}
                formErrors={formErrors}
                onChangeFormInput={onChangeFormInput}
              />
            ),
            [ShouldShowModal.detail]: <DetailContent data={eventMoneyTransfer} />,
            [ShouldShowModal.refuse]: (
              <RefuseContent
                formData={formDataRefuse}
                formErrors={formErrorsRefuse}
                onChangeFormInput={onChangeFormInputRefuse}
              />
            ),
          }[shouldShowModal]
        }
      </Dialog>
      <Container className="mainContainer" fluid={true}>
        <div className="d-flex justify-content-between" style={{ paddingBottom: '30px' }}>
          <h5 className="pageTitle">Solicitações de resgates</h5>
          <div className="button-filter-container">
            <div className="filter-container">
              <div
                className="filter-content"
                onClick={(): void => {
                  onShouldShowModal({ value: ShouldShowModal.filter, newTitleModal: 'Filtrar' });
                }}
              >
                <FilterVector />
              </div>
            </div>
          </div>
        </div>
        {groupedByEvent &&
          groupedByEvent.map(data => (
            <>
              <div
                style={{ fontSize: '20px', fontWeight: 'bold', marginTop: 32, marginBottom: 30 }}
              >
                {data.event.name}
              </div>
              <CustomTable
                columns={columns}
                data={dataTable(data.transfers)}
                numberRowsPerPage={page.total || 0}
                progressPending={state === States.loading}
              />
            </>
          ))}
        <Pagination
          currentPage={page.page}
          totalCount={page.total}
          pageSize={page.pageSize}
          onPageChange={(data: number) => onPaginationChange(data)}
          total={page.total}
        />
      </Container>
    </Fragment>
  );
};
